// Copyright (C) 2012 Minted Inc.
// All Rights Reserved

M.View = M.View || {};
M.View.ProductDetails = M.View.ProductDetails || {};

/**
 * Renders a paper picker HTML select list
 */
M.View.ProductDetails.RadioBindingPicker = Backbone.View.extend({
  events: {
    'change': 'onChange'
  },

  initialize: function() {
    this.$el = $(this.el);
    var that = this;

    var disabledBindings = this.model.getDisabledBindings();

    // Set a default binding if none is set, or an invalid binding is set
    if (this.model.get('bindingId') == undefined ||
        _(disabledBindings).contains(this.model.get('bindingId'))) {
      var binding;
      _(this.model.get('bindingOptionList')).each(function(_binding) {
        if (binding === undefined &&
            !_(disabledBindings).contains(_binding)) {
          binding = _binding;
        }
      });

      M.required(binding);
      this.model.set({
        bindingId: binding
      });
    };

    this.model.bind('priceUpdated', function() {
      that.render();
    });
  },

  template: _.template('\
<table class="radioFormatPicker radioPicker"> \
  <tbody> \
   <@ _(bindingOptionList).each(function(_bindingId) { \
        var isDisabled = _(disabledBindngs).contains(_bindingId); \
   @> \
    <tr> \
      <td class="input"> \
        <input type="radio" \
               id="binding-<@= _bindingId @>" \
               value="<@= _bindingId @>" \
               <@ if (isDisabled) { @> disabled="disabled" <@ } @> \
               <@ if (bindingId == _bindingId) { @> checked="checked" <@ } @>> \
      </td> \
      <td class="description"> \
        <label for="binding-<@= _bindingId @>" \
               class=" \
<@ if (bindingId == _bindingId) { @> checked <@ } @> \
<@ if (isDisabled) { @> disabled <@ } @>"> \
          <span class="type"> \
            <@= M.View.ProductDetails.BINDING_OPTION_LABELS[_bindingId] @> \
          </span> \
        </label>&nbsp;&nbsp;\
        <span class="caption <@ if (isDisabled) { @> disabled <@ } @>"> \
          <@= M.View.ProductDetails.BINDING_OPTION_CAPTIONS[_bindingId] @> \
        </span> \
       </td>\
       <td class="priceDelta"> \
         <span class="priceDiff <@ if (isDisabled) { @> disabled <@ } @> \
">+&nbsp;$<@= bindingPriceDiff[_bindingId] @></span> \
       </td>\
    </tr> \
   <@ }); @> \
  </tbody> \
</table> \
<a class="bindingDialogLink infoLink">about our bindings</a> \
'),

  getRenderContext: function() {
    return _(this.model.toJSON()).extend({
      bindingPriceDiff: this.model.getBindingPriceDiff(),
      disabledBindngs: this.model.getDisabledBindings()
    });
  },

  /**
   * Renders the HTML for the radio format picker input.
   */
  render: function() {
    var that = this;

    this.$el.html(this.template(this.getRenderContext()));

    // Truncate long paper option descriptions in order to keep
    // the "personalize" button above the fold.
    this.$el.find('.caption').jTruncate({
      length: 35, lessText: 'less'
    });

    // Bind to the 'more'/'less' link created by jTruncate.
    // Note: We are using the class of the link to find the element since
    // jTruncate does not return a reference to it. Binding to .caption does not
    // work because the link intercepts the click.
    this.$el.find('.truncate_more_link').click(function () {
      that.trigger('moreButtonClicked');
    });

    return this;
  },

  onChange: function(event) {
    var bindingId = parseInt($(event.target).val());
    this.trigger('bindingSelected', bindingId);
  }
});
